import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Injector,
  OnInit,
} from '@angular/core';
import { OpModalLocalsMap } from 'core-app/modules/modal/modal.types';
import { OpModalComponent } from 'core-app/modules/modal/modal.component';
import { OpModalLocalsToken } from "core-app/modules/modal/modal.service";
import { ConfigurationService } from 'core-app/modules/common/config/configuration.service';
import { LoadingIndicatorService } from 'core-app/modules/common/loading-indicator/loading-indicator.service';
import { I18nService } from "core-app/modules/common/i18n/i18n.service";
import { WorkPackageNotificationService } from "core-app/modules/work_packages/notifications/work-package-notification.service";
import { TimeEntriesCurrentUserConfigurationModalService } from "core-app/modules/grids/widgets/time-entries/current-user/configuration-modal/services/configuration-modal/configuration-modal.service";

@Component({
  templateUrl: './configuration.modal.html',
  providers: [TimeEntriesCurrentUserConfigurationModalService],
})
export class TimeEntriesCurrentUserConfigurationModalComponent extends OpModalComponent implements OnInit  {

  /* Close on escape? */
  public closeOnEscape = true;

  /* Close on outside click */
  public closeOnOutsideClick = true;

  public $element:JQuery;

  public text = {
    displayedDays: this.I18n.t('js.grid.widgets.time_entries_current_user.displayed_days'),
    closePopup: this.I18n.t('js.close_popup_title'),
    applyButton: this.I18n.t('js.modals.button_apply'),
    cancelButton: this.I18n.t('js.modals.button_cancel'),
  };

  public firstDayOfWeek:number;

  // Checked value of all days of the week, starting from Monday.
  public options:{ days:boolean[] };
  public daysOriginalCheckedValues:boolean[];
  public days:IDayData[];

  constructor(@Inject(OpModalLocalsToken) public locals:OpModalLocalsMap,
              readonly I18n:I18nService,
              readonly injector:Injector,
              readonly appRef:ApplicationRef,
              readonly loadingIndicator:LoadingIndicatorService,
              readonly notificationService:WorkPackageNotificationService,
              readonly cdRef:ChangeDetectorRef,
              readonly configuration:ConfigurationService,
              readonly elementRef:ElementRef,
              readonly timeEntriesCurrentUserConfigurationModalService:TimeEntriesCurrentUserConfigurationModalService) {
    super(locals, cdRef, elementRef);
  }

  ngOnInit() {
    this.daysOriginalCheckedValues = this.locals.options.days || Array.from({ length: 7 }, () => true );
    this.days = this.timeEntriesCurrentUserConfigurationModalService.getOrderedDaysData(this.daysOriginalCheckedValues);
  }

  public saveChanges():void {
    const checkedValuesInOriginalOrder= this.timeEntriesCurrentUserConfigurationModalService.getCheckedValuesInOriginalOrder(this.days);

    this.options = { days: checkedValuesInOriginalOrder };
    this.service.close();
  }
}
